export function formatCurrency(n) {
  const num = Number(n || 0);
  return "₹" + num.toLocaleString("en-IN", { maximumFractionDigits: 0 });
}

export function formatDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso.length <= 10 ? iso + "T00:00:00" : iso);
  if (isNaN(d)) return "—";
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  return d.toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

// Campaign progress: day X of Y + leads percentage
export function campaignInfo(order) {
  const target = Number(order?.target_leads || 0);
  const generated = Number(order?.generated_leads || 0);
  const remaining = Math.max(target - generated, 0);
  const leadPercent = target > 0 ? Math.min(Math.round((generated / target) * 100), 100) : 0;

  let totalDays = 0, currentDay = 0, dayPercent = 0;
  if (order?.start_date && order?.end_date) {
    const start = new Date(order.start_date + "T00:00:00");
    const end = new Date(order.end_date + "T00:00:00");
    const today = new Date();
    if (!isNaN(start) && !isNaN(end) && end >= start) {
      totalDays = Math.round((end - start) / 86400000) + 1;
      const elapsed = Math.round((today - start) / 86400000) + 1;
      currentDay = Math.min(Math.max(elapsed, 0), totalDays);
      dayPercent = totalDays > 0 ? Math.min(Math.round((currentDay / totalDays) * 100), 100) : 0;
    }
  }
  return { target, generated, remaining, leadPercent, totalDays, currentDay, dayPercent, hasTarget: target > 0 };
}

export function pendingAmount(order) {
  return Math.max(Number(order?.total_amount || 0) - Number(order?.paid_amount || 0), 0);
}
